<template>
  <ResponsiveLayout
    :progress="progress"
    :show-lang-picker="false"
    sticky-actions
    theme="blue-actions"
  >
    <template #header_start>
      <ButtonBack @click="emit('back')" />
    </template>
    <template #header_middle>
      <div class="kds-typography-title-medium">
        {{ $t('b2b_self_test_red_flags_question_title') }}
      </div>
    </template>
    <div class="kds-content-block">
      <h3
        class="kds-typography-title-xlarge"
        v-html="$t('b2b__red_flags_eu__sub_title')"
      />
      <div
        class="kds-typography-paragraph-large"
        v-html="$t('b2b__red_flags_eu__notes')"
      />
    </div>
    <template #actions>
      <CheckboxField
        data-qa="precautions-red-flag-checkbox"
        :label="$t('b2b__red_flags_eu__checkbox_label__medically_clear')"
        :model-value="redFlagApproved"
        @update:model-value="handleConfirmationBoxChange"
      />
      <BaseButton
        :disabled="!redFlagApproved"
        :text="$t('b2b_sign_up_submit_button_text')"
        data-qa="submit"
        @click="next"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import useSelfTestStore from '@shared/modules/assessment/stores/useSelfTestStore.js'
import { ref } from 'vue'
import { useI18n } from 'petite-vue-i18n'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import ButtonBack from '@shared/components/ButtonBack.vue'
import BaseButton from '@shared/components/BaseButton.vue'
import CheckboxField from '@shared/components/form/CheckboxField.vue'

const selfTestStore = useSelfTestStore()
const { t } = useI18n()

const props = defineProps({
  progress: {
    type: Number,
    default: null,
  },
  handleNextEvent: {
    type: Function,
    default: () => {},
  },
})

const emit = defineEmits(['back'])

const redFlagApproved = ref(selfTestStore.redFlagApproved)

const handleConfirmationBoxChange = (checked) => {
  redFlagApproved.value = checked
}

const next = () => {
  if (!redFlagApproved.value) return
  selfTestStore.answer('red_flag_approved', {
    value: 1,
    text: t('b2b__red_flags_eu__checkbox_label__medically_clear'),
    questionText: t('b2b__red_flags_eu__sub_title'),
  })
  props.handleNextEvent()
}
</script>
